import {MerkleTree} from "merkletreejs";
import keccak256 from "keccak256";


export const getWalletProof = (walletAddress: string, whitelistAddress: string[]) => {

    const leafNodes = whitelistAddress.map(addr => keccak256(addr));
    const merkleTree = new MerkleTree(leafNodes, keccak256, {sortPairs: true});

    const claimingAddress = keccak256(walletAddress);
    const hexProof = merkleTree.getHexProof(claimingAddress);

    return hexProof;
};

